import React, { ReactNode, useEffect } from 'react';
import { Close } from '../Helpers/icons/Icons';

type PropsType = {
  children?: ReactNode;
  onClose: () => void;
  title: string;
  className?: string;
};

const PrimaryPopup = ({ children, onClose, title, className = '' }: PropsType) => {
  useEffect(() => {
    const onKey = (e: KeyboardEvent) => e.key === 'Escape' && onClose();
    document.addEventListener('keydown', onKey);
    document.body.style.overflow = 'hidden';

    return () => {
      document.removeEventListener('keydown', onKey);
      document.body.style.overflow = '';
    };
  }, [onClose]);

  return (
    <div
      role='dialog'
      aria-modal='true'
      aria-label={title}
      className='fixed inset-0 z-[100] flex justify-center overflow-y-auto p-0 sm:p-5'
    >
      <div
        onClick={onClose}
        aria-hidden='true'
        className='animate-fade-in fixed inset-0 bg-ink-900/55 backdrop-blur-[3px]'
      />

      <div
        className={`animate-rise-in relative z-10 h-fit w-full bg-paper px-4 pt-7 sm:my-auto
          sm:rounded-card sm:px-9 sm:shadow-pop ${className}`}
      >
        <div className='mb-7 flex items-start justify-between gap-4'>
          {title ? <h2 className='display-sm'>{title}</h2> : <span />}
          <button
            type='button'
            onClick={onClose}
            aria-label='Close'
            className='-mr-1 -mt-1 flex h-9 w-9 flex-none items-center justify-center rounded-pill
              text-ink-500 transition-colors hover:bg-canvas hover:text-ink-900'
          >
            <Close size={19} />
          </button>
        </div>
        {children}
      </div>
    </div>
  );
};

export default PrimaryPopup;
